import { dataexportConstants } from './dataexportConstants';
import {userConstants} from "../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  inProgress: true,
});

export function dataexports(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case dataexportConstants.DATAEXPORT_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case dataexportConstants.DATAEXPORT_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.dataexports.rows ? action.dataexports.rows : [],
        total: action.dataexports.total ? action.dataexports.total : 0,
        inProgress: false,
      };
    case dataexportConstants.DATAEXPORT_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case dataexportConstants.DATAEXPORT_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case dataexportConstants.DATAEXPORT_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        shouldReload
      };
    }

    case dataexportConstants.DATAEXPORT_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case dataexportConstants.DATAEXPORT_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
        }
      }
      return {
        ...state,
        requestSaveActive: false,
      }
    case dataexportConstants.DATAEXPORT_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
